import { render, staticRenderFns } from "./antropometri.vue?vue&type=template&id=26d2208a&scoped=true&"
import script from "./antropometri.vue?vue&type=script&lang=js&"
export * from "./antropometri.vue?vue&type=script&lang=js&"
import style0 from "./antropometri.vue?vue&type=style&index=0&id=26d2208a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d2208a",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CInputRightAddon: require('@chakra-ui/vue').CInputRightAddon, CBox: require('@chakra-ui/vue').CBox})
